import { forwardRef, ReactNode, useImperativeHandle, useState } from "react";
import {
  CardOption,
  Container,
  Content,
  CustomBadge,
  Header,
  Main,
} from "./styles";

export type ActiveTabType = 'viewpoint' | 'attachement' | 'comments' | 'history';

export type ITabMap = Map<ActiveTabType, ITab>;

export interface ITab {
  id: ActiveTabType;
  label: string;
  isDisabled: boolean;
  tagNumber?: number;
  newTagNumber?: number;
  children: ReactNode;
  customContentPadding?: string;
};

interface ITabs {
  defaultActiveTab: ActiveTabType;
  options: ITabMap;
  loadingExternalLink: boolean;
}

export interface TabsRef {
  onActiveTab: (tabId: ActiveTabType) => void;
}

const Tabs = forwardRef<TabsRef, ITabs>(({
  defaultActiveTab,
  options,
  loadingExternalLink,
}, ref) => {
  const [activeTab, setActiveTab] = useState<ActiveTabType>(defaultActiveTab);

  const optionsArray = Array.from(options);

  const handleActiveTab = (tabId: ActiveTabType) => {
    setActiveTab(tabId);
  };

  useImperativeHandle(ref, () => ({
    onActiveTab: handleActiveTab,
  }), []);

  return (
    <Container>
      <Header>
        {optionsArray.map(([id, option]) => {
          const isActive = id === activeTab;
          const hasNewTag = option.newTagNumber && option.newTagNumber > 0;

          return (
            <CardOption
              key={id}
              isactive={`${!loadingExternalLink && isActive}`}
              isdisabled={`${loadingExternalLink || option.isDisabled}`}
              onClick={() => (loadingExternalLink || option.isDisabled) ? undefined : handleActiveTab(id)}
            >
              <span className="cardOptionsText">{option.label}</span>
              {(!loadingExternalLink && !hasNewTag && option.tagNumber && option.tagNumber > 0) ? (
                <CustomBadge>{option.tagNumber}</CustomBadge>
              ) : null}
              {(!loadingExternalLink && option.newTagNumber && option.newTagNumber > 0) ? (
                <CustomBadge isnew>
                  {option.newTagNumber}
                </CustomBadge>
              ) : null}
            </CardOption>
          )
        })}
      </Header>

      <Content style={{ padding: options.get(activeTab)?.customContentPadding }}>
        <Main>
          {options.get(activeTab)?.children}
        </Main>
      </Content>
    </Container>
  )
});

export default Tabs;
